<script setup>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

defineProps({
    url: String,
})

const visible = defineModel('visible')

function proceed(url) {
    visible.value = false;
    window.location.href = url;
}
</script>

<template>
    <Dialog v-model:visible="visible" modal :closable="false" :draggable="false" class="max-w-md w-full mx-4">
        <template #header>
            <div class="flex items-center gap-2">
                <span class="text-xs font-black">{{ $t('widget.linksguard_title') }}</span>
            </div>
        </template>

        <div class="flex flex-col gap-4 py-1">
            <div class="flex items-start gap-3">
                <div class="w-10 h-10 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center shrink-0">
                    <span class="pi pi-external-link text-amber-600 !text-base"></span>
                </div>
                <div>
                    <p class="font-semibold text-gray-900 dark:text-white">{{ $t('widget.linksguard_heading') }}</p>
                    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">{{ $t('widget.linksguard_description') }}</p>
                </div>
            </div>

            <div class="bg-gray-50 dark:bg-neutral-800 rounded-lg p-3 border dark:border-neutral-700">
                <p class="text-xs text-gray-400 dark:text-gray-500 mb-1 uppercase tracking-wide">{{ $t('widget.linksguard_destination') }}</p>
                <p class="text-sm font-mono text-gray-700 dark:text-gray-200 break-all">{{ url }}</p>
            </div>
        </div>

        <template #footer>
            <div class="flex gap-2 justify-end">
                <Button :label="$t('widget.linksguard_cancel')" severity="secondary" size="small" @click="visible = false" />
                <Button :label="$t('widget.linksguard_proceed')" size="small" icon="pi pi-external-link" @click="proceed(url)" />
            </div>
        </template>
    </Dialog>
</template>
